export default __webpack_public_path__ + "static/media/21.e5058132.png";